import { CheckCircleOutlined } from '@ant-design/icons'
import { useRequest } from 'ahooks'
import { Popconfirm, Tooltip } from 'antd'
import moment from 'moment'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { ProjectStage } from '@/schemas'

interface StageCompleterProps {
  stage: ProjectStage
  onSuccess: () => void
}

export const StageCompleter: React.FC<StageCompleterProps> = ({ stage, onSuccess }) => {
  const { t } = useTranslation()
  const { run } = useRequest(
    (data) => ({
      url: '/api/project/updateProjectStage',
      method: 'post',
      data: {
        ...data,
        selfId: stage.selfId,
        id: stage.id,
      },
    }),
    {
      manual: true,
    }
  )

  const onUpdate = async () => {
    if (stage.progress === 100) {
      return
    }
    await run({
      progress: 100,
      actualEndDate: moment().format('ll'),
    })
    onSuccess()
  }

  return (
    <Popconfirm title={t('quckly complete')} onConfirm={() => onUpdate()}>
      <Tooltip title={t('mark complete')}>
        <CheckCircleOutlined className='mr-12px transition hover:text-green-600' />
      </Tooltip>
    </Popconfirm>
  )
}
